module.exports = __webpack_public_path__ + "img/xml.b5e4d3e5.svg";